import React from 'react';
import { Skeleton } from '@mui/material';
import IncidentAPI from '../../redux/incident/api/IncidentAPI';
import EventTitleTranslation from './Translations/EventTitleTranslation';

interface IncidentTitleProps {
  alarmId: string;
}
function IncidentTitle(props: IncidentTitleProps) {
  const { alarmId } = props;
  const {
    data: incident,
    isFetching: isFetchingIncident,
    isLoading: isLoadingIncident,
  } = IncidentAPI.useGetIncidentByIdQuery(alarmId, {
    skip: !alarmId,
  });

  const isLoading = isLoadingIncident || isFetchingIncident;

  if (!alarmId) return null;
  if (isLoading) return <Skeleton variant="text" width={60} />;
  if (incident)
    return (
      <EventTitleTranslation
        eventId={incident?.event}
        deviceId={incident?.deviceId}
        controlUnitId={incident?.cu}
        fallback={incident?.event}
      />
    );
  return null;
}

export default IncidentTitle;
